var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('responsive-dialog',{ref:"responsive_dialog",attrs:{"dialog-title":_vm.dialogTitle,"show-actions":false}},[_c('submission-form',{ref:"submission_form",attrs:{"submission":_vm.submission},on:{"updated":_vm.close}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }